export type MarcheCode = 'sante' | 'prevoyance' | 'emprunteur' | 'financement' | 'epargne-retraite';

export type MarqueClientCode =
  | 'alptis'
  | 'miltis'
  | 'msh'
  | 'unep'
  | 'capvita'
  | 'belend'
  | 'pret-pro'
  | 'groupe-mncap'
  | 'oradea-vie'
  | 'cnp-assurances'
  | 'malakoff-humanis';

export const ReseauDistributionCodeMap = {
  ALPTIS: 'ALPTIS',
  MILTIS: 'MILTIS',
} as const;

export type ReseauDistributionCode = (typeof ReseauDistributionCodeMap)[keyof typeof ReseauDistributionCodeMap];

export const OffreRubriqueCodeMap = {
  SANTE_INDIVIDUELLE: 'sante-individuelle',
  PREVOYANCE: 'prevoyance',
  EMPRUNTEUR_FINANCEMENT: 'emprunteur-financement',
  COLLECTIF: 'collectif',
  EPARGNE_RETRAITE: 'epargne-retraite',
} as const;

export type OffreRubriqueCode = (typeof OffreRubriqueCodeMap)[keyof typeof OffreRubriqueCodeMap];

export function isOffreRubriqueCode(code: unknown): code is OffreRubriqueCode {
  return typeof code === 'string' && Object.values(OffreRubriqueCodeMap).includes(code as OffreRubriqueCode);
}
